/**
 * Replaces hyphens with spaces while preserving "e-tron" as a special case
 * @param str - The input string to process
 * @returns The string with hyphens replaced by spaces, except in "e-tron"
 */
const removeHyphens = (str: string): string => {
  // First, temporarily replace "e-tron" with a placeholder to protect it
  const placeholder = '___ETRON___';
  const etronProtectedStr = str.replace(/e-tron/g, placeholder);

  // Replace all remaining hyphens with spaces
  const withSpaces = etronProtectedStr.replace(/-/g, ' ');

  // Restore the protected "e-tron" instances
  return withSpaces.replace(new RegExp(placeholder, 'g'), 'e-tron');
};

export { removeHyphens };
